module.exports = __webpack_public_path__ + "static/media/splash.e6577eca.png";